import GetBasicDetails from './GetBasicDetails';

export {
  GetBasicDetails
};

export default GetBasicDetails;